import type { TreeApi } from 'react-arborist'
import { proxy, ref, useSnapshot } from 'valtio'
import type { TreeItem } from '@/types'

const _localStorageId = 'tidal-sandbox/tree-state'

type TreeStateAtom = {
  version: number
  treeApi: TreeApi<TreeItem> | undefined
}

export const treeStateStore = proxy<TreeStateAtom>({
  treeApi: undefined,
  version: 2,
})

export function setTreeApi(value: TreeApi<TreeItem> | undefined) {
  treeStateStore.treeApi = value ? ref(value) : undefined
}

export function collapseAll() {
  treeStateStore.treeApi?.closeAll()
}

export function expandAll() {
  treeStateStore.treeApi?.openAll()
}

export function expandToSlug(slug?: string) {
  if (slug) {
    treeStateStore.treeApi?.focus(slug)
  }
}

export function useTreeApi(): TreeApi<TreeItem> | undefined {
  return useSnapshot(treeStateStore).treeApi as TreeApi<TreeItem> | undefined
}
